import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useLearning } from 'src/hook/data/useLearning';
import { useWords } from 'src/hook/data/useWords';
import useWindowSize from 'src/hook/global/useWidowSize';
import { SenseImageLocation } from 'src/utils/URLUtils';
import styles from './ReviewSection.module.scss';

export const ReviewSection = () => {
    const { t, i18n } = useTranslation();
    const [thumbnails, setThumbnails] = useState<string[]>([]);
    const [loadedImages, setLoadedImages] = useState<{ [key: number]: boolean }>({});
    const { learningInfo } = useLearning();
    const navigate = useNavigate();
    const { getWordById } = useWords();
    const { isDesktop } = useWindowSize();

    useEffect(() => {
        const thumbnailCount = isDesktop() ? 8 : 4;
        const topReviews = learningInfo?.ReviewWordIds.slice(0, thumbnailCount) || [];
        const wordIds = topReviews.map(review => review.split(':;')[0]);
        const thumbnails = wordIds.map(id =>
            SenseImageLocation(getWordById(parseInt(id))?.PrimarySenseId ?? ''));
        setThumbnails(thumbnails);
    }, [learningInfo, getWordById, isDesktop]);

    const handleImageLoad = (index: number) => {
        setLoadedImages(prev => ({ ...prev, [index]: true }));
    };

    if ((learningInfo?.ReviewWordIds?.length ?? 0) === 0) return null;

    if (thumbnails.length === 0) return null;

    return (
        <div className={styles.reviewSection}>
            <h2 className='homeTitle'>{t("Today's Reviews")}</h2>
            <p dir={i18n.dir()} className='homeSubtitle'>{t('Words and phrases due for review.')}</p>

            <div className={styles.reviewSectionContent}>
                <div className={styles.countSection}>
                    <span className={styles.count}>{learningInfo?.ReviewWordIds.length}</span>
                    <div className={styles.thumbnails}>
                        {thumbnails.map((thumbnail, index) => (
                            <div key={index} className={styles.thumbnailContainer}>
                                <img
                                    loading='eager'
                                    src={thumbnail}
                                    alt=""
                                    className={`${styles.thumbnail} ${loadedImages[index] ? styles.loaded : ''}`}
                                    onLoad={() => handleImageLoad(index)}
                                />
                            </div>
                        ))}
                    </div>
                </div>

                <button className={styles.startButton}
                    onClick={() => navigate('/challenges')}>
                    {t('Start')}
                </button>
            </div>
        </div>
    );
};
